module.exports = __webpack_public_path__ + "static/media/bathtub.ec0891fe.svg";